import React from "react";
import HunterProfileSetup from "./HunterProfileSetup";

function formatDate(dateValue) {
  if (!dateValue) return "Unknown";
  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return "Unknown";
  return parsed.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

function formatFocusMinutes(value) {
  const minutes = Number(value || 0);
  return minutes > 0 ? `${minutes} min` : "Unspecified";
}

const ProfilePage = ({ user, profile, onSave }) => {
  const displayName =
    profile?.displayName ||
    user?.rawUser?.user_metadata?.user_name ||
    user?.displayName ||
    user?.email ||
    "Unnamed Hunter";

  if (!profile) {
    return (
      <div className="profile-page">
        <section className="stats-card profile-shell">
          <div className="profile-shell__label">[ HUNTER PROFILE ]</div>
          <h4>Retrieving System records...</h4>
        </section>
      </div>
    );
  }

  const summaryItems = [
    { label: "Hunter ID", value: displayName },
    { label: "Registered Email", value: user?.email || "Unavailable" },
    { label: "Current Rank", value: profile.currentTitle || "Weakest Hunter of Mankind" },
    { label: "Level", value: `Level ${profile.level || 1}` },
    {
      label: "Wake / Sleep Cycle",
      value:
        profile.wakeTime && profile.sleepTime
          ? `${profile.wakeTime} / ${profile.sleepTime}`
          : "Unspecified",
    },
    {
      label: "System Timezone",
      value: profile.timeZone || "UTC",
    },
    {
      label: "Preferred Focus Block",
      value: formatFocusMinutes(profile.preferredFocusMinutes),
    },
    {
      label: "Daily Quest Load",
      value: `${profile.questsPerDay || 5} system quests`,
    },
    {
      label: "System Record Opened",
      value: formatDate(profile.createdAt),
    },
    {
      label: "Last Profile Revision",
      value: formatDate(profile.updatedAt || profile.createdAt),
    },
  ];

  return (
    <div className="profile-page">
      <section className="stats-card profile-shell profile-shell--summary">
        <div className="profile-shell__header">
          <div className="profile-shell__label">[ HUNTER RECORD ]</div>
          <h4>System Identity Ledger</h4>
          <p className="profile-shell__copy">
            The System keeps this file active. Revise your baseline when your
            current life changes. Future directives will adapt.
          </p>
        </div>

        <div className="profile-summary">
          {summaryItems.map((item) => (
            <div key={item.label} className="profile-summary__item">
              <div className="profile-summary__label">{item.label}</div>
              <div className="profile-summary__value">{item.value}</div>
            </div>
          ))}
        </div>
      </section>

      <HunterProfileSetup
        mode="page"
        profile={profile}
        onSave={onSave}
      />
    </div>
  );
};

export default ProfilePage;
